export const GOOGLE_SRC = "https://accounts.google.com/gsi/client";
